import React from 'react';
import { ChatConfig } from '../types';
import { getBrandingColor } from '../utils/brandingUtils';

interface HelperButtonsProps {
  config: ChatConfig | null;
  onButtonClick: (option: string) => void;
}

/**
 * Renders helper buttons at the beginning of the chat to help users get started quickly.
 */
export const HelperButtons: React.FC<HelperButtonsProps> = ({
  config,
  onButtonClick,
}) => {
  // Get the primary color from config for styling
  const primaryColor = config?.branding?.colors?.primary || '#3b82f6';
  
  return (
    <div className="helper-buttons-container flex flex-col items-center space-y-3 my-6">
      <p className="text-center text-sm text-gray-500 mb-1">What can I help you with today?</p>
      <div className="flex flex-col space-y-3 w-full max-w-xs">
        <button
          className="px-4 py-3 bg-white text-center rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors shadow-sm font-medium"
          style={{ color: primaryColor }}
          onClick={() => onButtonClick('Find the Right Mattress')}
        >
          Find the Right Mattress
        </button>
        
        <button
          className="px-4 py-3 bg-white text-center rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors shadow-sm font-medium"
          style={{ color: primaryColor }}
          onClick={() => onButtonClick('Something Else')}
        >
          Something Else
        </button>
      </div>
    </div>
  );
}; 